import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { OpenInNew } from "@material-ui/icons";
import BasicPageTemplate from "../organisms/BasicPageTemplate";
import { get_vtuber, reset_vtuber_name } from "../../actions/vtuber";
import Wrapper from "../atoms/Wrapper";
import TwitterButton from "../organisms/TwitterButton";
import YouTubeButton from "../organisms/YouTubeButton";
import Link from "../atoms/Link";
import AddMyListButton from "../organisms/AddMyListButton";
import VTuberVideoStream from "../organisms/VTuberVideoStream";
import Tabs from "../organisms/Tabs";
import RelatedVTuberStream from "../organisms/RelatedVTuberStream";
import Tags from "../organisms/Tags";
import { update_tags } from "../../actions/tag";
import ReportForm from "../organisms/ReportForm";
import VTuberIntroducitonStream from "../organisms/VTuberIntroductionStream";
import MobileComponent, {
  Other as NotMobileComponent,
} from "../atoms/MobileComponent";
import VTubersClipStream from "../organisms/VTubersClipStream";
import SubscriberNumLogTable from "../organisms/SubscriberNumLogTable";

const TopWrapper = styled(Wrapper)`
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow: hidden;

  ::before {
    content: "a";
    background: inherit;
    filter: blur(12px) contrast(1.1);
    position: absolute;
    top: -16px;
    left: -16px;
    right: -16px;
    bottom: -16px;
  }
  background: ${(props) => props.theme.colors.gray100};
  ${(props) =>
    props.image_url
      ? `background: radial-gradient(rgba(237, 237, 237, 0.9), rgba(236, 236, 236, 0.9)), rgba(32, 137, 241, 0.15);`
      : ""}

  background-size: cover;

  padding: 4.5rem 0;
  margin-bottom: 1.1rem;
  position: relative;

  @media (max-width: 450px) {
    padding: 3rem 0;
  }
`;

const Top = styled(Wrapper)`
  width: 100%;
  position: relative;
  overflow: hidden;
  align-items: flex-start;

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Name = styled(Wrapper)`
  font-size: 2rem;
  margin-top: 1.2rem;
  z-index: 2;
  margin-left: -0.18rem;
`;

const Phrase = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  /* color: ${(props) => props.theme.colors.gray200}; */
  color: rgba(0, 0, 0, 0.06);
  height: 100%;
  width: 100%;
  padding: 0 1rem;
  font-size: 4rem;
  line-height: 6rem;
  z-index: 1;
`;

const StyledAvatar = styled.img`
  height: 200px;
`;

const AvatarWrapper = styled(Wrapper)`
  width: 200px;
  min-width: 200px;
  height: 200px;
  border-radius: 99999px;
  margin: 1.5rem 2.5rem;
  box-shadow: 0 2px 4px ${(props) => props.theme.colors.shadow};
  background: ${(props) => props.theme.colors.white100};
  overflow: hidden;
  z-index: 2;
`;

const SNSWrapper = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-rows: 1fr 1fr;
  margin-top: 2.2rem;
  z-index: 2;
  width: 20rem;
  max-width: 100%;
  grid-template-columns: 100%;

  @media (min-width: 761px) and (max-width: 1000px) {
    width: 16rem;
  }
`;

const Description = styled(Wrapper)`
  width: 100%;
  margin-top: 1.8rem;
  padding-right: 4rem;
  z-index: 2;
  justify-content: flex-start;

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
`;

const TopRight = styled(Wrapper)`
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: calc(100% - 200px - 5rem);

  @media (max-width: 760px) {
    flex-direction: column;
    width: 85%;
    max-width: 85%;
  }
`;

const Group = styled(Wrapper)`
  width: 100%;
  justify-content: flex-start;
`;

const GroupName = styled.span`
  text-overflow: ellipsis;
  color: ${(props) => props.theme.colors.black100};
  line-height: 1rem;
  font-size: 1.3rem;
`;

const StyledLink = styled(Link)`
  justify-content: flex-start;
  padding: 1.2rem 0;
  z-index: 99;
`;

const TopBottom = styled(Wrapper)`
  width: 100%;
  padding-right: 4rem;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 760px) {
    flex-direction: column;
    padding: 0;
  }
`;

const VTuberVideoWrapper = styled(Wrapper)`
  width: 100%;
`;

const AddMyListButtonWrapper = styled.div`
  margin-top: 2.2rem;
  padding: 0 5px;
  z-index: 99;
`;

const TagsWrapper = styled(Wrapper)`
  margin-top: 2.2rem;
  padding: 0 4rem 0 5px;
  width: 100%;
  justify-content: flex-start;
  z-index: 99;

  @media (max-width: 760px) {
    padding: 0 5px;
  }
`;

const IntroWrapper = styled(Wrapper)`
  margin-top: 2.2rem;
  margin-bottom: 1.6rem;
  padding: 0 0 0.3rem;
  width: 95%;
  overflow: auto;
  justify-content: flex-start;
  z-index: 99;
  box-shadow: inset -4px 0 4px -4px rgba(0, 0, 0, 0.18),
    inset 4px 0 4px -4px rgba(0, 0, 0, 0.18);
`;

const TopRightTop = styled(Wrapper)`
  z-index: 99;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 4rem;

  @media (max-width: 760px) {
    padding: 0;
  }
`;

const MyVTuberListsCount = styled(Wrapper)`
  justify-content: flex-start;
  padding-left: 0.4rem;
  padding-right: calc(5px + 24px);

  @media (max-width: 450px) {
    padding-right: 0;
    padding-left: calc(24px + 5px + 2px);
  }
`;
const MyVTuberListsCountLabel = styled(Wrapper)`
  margin-right: 0.5rem;
  color: ${(props) => props.theme.colors.gray};
  font-size: 0.9rem;
`;
const MyVTuberListsCountValue = styled(Wrapper)`
  color: ${(props) => props.theme.colors.gray};
`;

const MyList = styled(Wrapper)`
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 450px) {
    align-items: flex-start;
  }
`;

const StyledMobileComponent = styled(MobileComponent)`
  width: 85%;
  max-width: 85%;
  z-index: 99;
`;

const OtherURLWrapper = styled(Wrapper)`
  justify-content: flex-start;
  padding: 0 5px;
  width: 100%;
`;
const OtherURL = styled.a`
  color: ${(props) => props.theme.colors.black};
  text-decoration: none;
  font-size: 1rem;
  width: 100%;
`;
const OtherURLIconWrapper = styled(Wrapper)`
  margin-right: 0.8rem;
  width: 34px;
  height: 34px;
  border-radius: 9999px;
  background: ${(props) => props.theme.colors.secondary};
`;
const OtherURLTitleWrapper = styled(Wrapper)`
  color: ${(props) => props.theme.colors.black100};
  justify-content: flex-start;
`;
const OtherURLLinkTitleWrapper = styled.a`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: calc(100% - 34px - 0.8rem);
`;

const Vtuber = (props) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(get_vtuber(props.match.params.id));
  }, [dispatch, props.match.params.id]);

  const {
    name,
    image,
    youtube_channels,
    twitter_id,
    groups,
    description,
    phrase,
    is_added,
    tags,
    my_vtuber_lists_count,
    url,
    link_title,
  } = useSelector((state) => state.vtuber);
  const group = groups && groups.length > 0 && groups[0];
  const youtube_channel =
    youtube_channels && youtube_channels.length > 0 && youtube_channels[0];

  React.useEffect(() => {
    document.title = `VTubers - ${name}`;
    window.scrollTo(0, 0);
  }, [name]);

  const handleSaveTags = (new_tags) => {
    dispatch(update_tags("vtubers", props.match.params.id, new_tags));
  };

  const labels = ["クリップ", "登録者数推移", "関連動画", "あなたへのおすすめ"];
  const contents = [
    <VTubersClipStream name={name} />,
    <SubscriberNumLogTable vtuber_id={props.match.params.id} />,
    <VTuberVideoStream name={name} />,
    <RelatedVTuberStream vtuber_id={props.match.params.id} />,
  ];

  React.useEffect(() => {
    return () => {
      dispatch(reset_vtuber_name());
    };
  }, [dispatch]);

  const [open, setOpen] = React.useState(false);
  const is_signed_in = useSelector(
    (state) => state.reduxTokenAuth.currentUser.isSignedIn
  );

  const handleOpen = (e) => {
    if (is_signed_in) {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BasicPageTemplate leftDrawerOpen>
      {image && (
        <Helmet>
          <meta name="twitter:card" content="summary_large_image" />
          <meta property="og:image" content={image} />
          <meta property="og:title" content={`${name} | VTubers`} />
          <meta property="og:description" content={description} />
          <meta
            property="og:url"
            content={`https://vtubers.love/vtubers/${props.match.params.id}`}
          />
        </Helmet>
      )}
      <TopWrapper image_url={image}>
        <Top>
          <StyledMobileComponent>
            <Button onClick={handleOpen} color="primary">
              修正報告
            </Button>
          </StyledMobileComponent>
          <AvatarWrapper>
            <StyledAvatar src={image} alt={name} />
          </AvatarWrapper>
          <TopRight>
            <TopRightTop>
              <Name>{name}</Name>
              <NotMobileComponent>
                <Button onClick={handleOpen} color="primary">
                  修正報告
                </Button>
              </NotMobileComponent>
            </TopRightTop>
            {group && (
              <StyledLink to={group ? `/groups/${group.id}` : ""}>
                <Group>
                  <GroupName>{group && group.name}</GroupName>
                </Group>
              </StyledLink>
            )}
            <Description>{description}</Description>

            <TopBottom>
              <SNSWrapper>
                {youtube_channel && (
                  <YouTubeButton
                    youtube={
                      youtube_channel && youtube_channel.youtube_channel_id
                    }
                    subscribeCount={
                      youtube_channel && youtube_channel.subscriber_num
                    }
                    big
                  />
                )}
                {twitter_id && (
                  <TwitterButton
                    twitter_id={twitter_id}
                    placeholder="未設定"
                    big
                  />
                )}
                {url && (
                  <OtherURLWrapper>
                    <OtherURL
                      target="_blank"
                      rel="noopener noreferrer"
                      href={url}
                    >
                      <OtherURLTitleWrapper>
                        <OtherURLIconWrapper>
                          <OpenInNew
                            style={{
                              width: 18,
                              height: 18,
                              color: "rgba(238, 238, 239, 1.0)",
                            }}
                          />
                        </OtherURLIconWrapper>
                        <OtherURLLinkTitleWrapper>
                          {link_title ? link_title : "リンク"}
                        </OtherURLLinkTitleWrapper>
                      </OtherURLTitleWrapper>
                    </OtherURL>
                  </OtherURLWrapper>
                )}
              </SNSWrapper>
              {props.match.params.id && (
                <MyList>
                  <AddMyListButtonWrapper>
                    <AddMyListButton
                      id={props.match.params.id}
                      is_added={is_added}
                      size="large"
                      icon_size="34px"
                    />
                  </AddMyListButtonWrapper>
                  <MyVTuberListsCount>
                    <MyVTuberListsCountLabel>
                      マイリスト数
                    </MyVTuberListsCountLabel>
                    <MyVTuberListsCountValue>
                      {my_vtuber_lists_count ? my_vtuber_lists_count : 0}
                    </MyVTuberListsCountValue>
                  </MyVTuberListsCount>
                </MyList>
              )}
            </TopBottom>
            <TagsWrapper>
              <Tags
                tags={tags ? tags : []}
                w="vtuber"
                editable
                saveTags={handleSaveTags}
              />
            </TagsWrapper>
          </TopRight>
          <Phrase>{phrase}</Phrase>
        </Top>
        <IntroWrapper>
          <VTuberIntroducitonStream
            vtuber_id={props.match.params.id}
            name={name}
          />
        </IntroWrapper>
        <Link to={`/forum/introductions/new?v=${props.match.params.id}`}>
          <Button color="primary">このVTuberの紹介を書く</Button>
        </Link>
      </TopWrapper>
      <VTuberVideoWrapper>
        <Tabs
          type={`vtuber${props.match.params.id}`}
          labels={labels}
          contents={contents}
        />
      </VTuberVideoWrapper>
      <Modal open={open && is_signed_in} onClose={handleClose}>
        <div>
          <ReportForm type={`「${name}」の情報修正`} />
        </div>
      </Modal>
    </BasicPageTemplate>
  );
};

export default Vtuber;
